import { api } from '../lib/api';
import { formatBytes, formatCount } from '../lib/format';
import { href } from '../lib/route';
import { useLoad } from '../lib/useLoad';
import { Loading, Stat } from '../components/bits';
import { PageHead, Section } from '../components/Shell';

interface Props {
  readonly token: string;
}

export const Overview = ({ token }: Props) => {
  const loaded = useLoad(() => api.overview(token), [token]);

  return (
    <>
      <PageHead eyebrow="Overview" title="The whole deployment" lede="Every number here is read from the same rows the frames run on." />
      <Loading loaded={loaded}>
        {(o) => (
          <div className="stack-loose">
            <Section title="People" aside={<a href={href('/accounts')}>All accounts →</a>}>
              <div className="stats">
                <Stat label="Accounts" value={formatCount(o.accounts)} />
                <Stat label="New, 7 days" value={formatCount(o.accountsLast7d)} />
                <Stat label="New, 30 days" value={formatCount(o.accountsLast30d)} />
                <Stat label="Active, 30 days" value={formatCount(o.activeAccounts30d)} note="seen on a live session" />
                <Stat label="Live sessions" value={formatCount(o.liveSessions)} />
                <Stat label="Locked out" value={formatCount(o.lockedAccounts)} note="too many wrong passwords" />
              </div>
            </Section>

            <Section title="Frames and screens" aside={<a href={href('/frames')}>All frames →</a>}>
              <div className="stats">
                <Stat label="Frames" value={formatCount(o.devices)} note="circles, in the coming model" />
                <Stat label="Screens paired" value={formatCount(o.screensLive)} />
                <Stat label="Seen today" value={formatCount(o.screensSeen24h)} note="polled in the last 24 h" />
                <Stat label="Albums" value={formatCount(o.albums)} />
                <Stat label="Albums on frames" value={formatCount(o.publicationsLive)} />
              </div>
            </Section>

            <Section title="Pictures" aside={<a href={href('/photos')}>All photos →</a>}>
              <div className="stats">
                <Stat label="On frames" value={formatCount(o.photosApproved)} note="approved placements" />
                <Stat label="Awaiting approval" value={formatCount(o.photosPending)} />
                <Stat label="Distinct pictures" value={formatCount(o.assets)} note="assets in R2" />
                <Stat label="Storage" value={formatBytes(o.assetBytes)} note="display sizes; thumbnails extra" />
              </div>
            </Section>
          </div>
        )}
      </Loading>
    </>
  );
};
